import { IPlayerGroup } from "./../../entities";
import { provider } from "../../providers";

export interface JoinGroupPayload {
  join_code: string;
  playerId: number;
}

export const JoinGroup = async (params: JoinGroupPayload): Promise<IPlayerGroup> =>
  provider.Request("/join-group", params);
